// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Attachment: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" enableBackground="new 0 0 24 24" xmlSpace="preserve">
<path d="M4.51,22.74L4.51,22.74c-1.13,0-2.17-0.44-2.95-1.23C-0.27,19.66-0.1,17.17,2,15.03L13.84,2.98
	c1.09-1.11,2.54-1.72,4.08-1.72c1.54,0,3,0.61,4.08,1.72c2.24,2.28,2.24,6,0,8.28L11.69,21.77l-1-0.98l10.32-10.51
	c1.71-1.74,1.71-4.58,0-6.32c-0.83-0.84-1.92-1.3-3.09-1.3c-1.16,0-2.26,0.46-3.09,1.3L3,16.01c-1.58,1.61-1.74,3.21-0.45,4.52
	c0.51,0.52,1.2,0.81,1.95,0.81h0c0.93,0,1.87-0.43,2.63-1.2l9.51-9.69c0.54-0.55,0.54-1.45,0-2c-0.52-0.53-1.41-0.52-1.92,0
	l-7.92,8.06l-1-0.98l7.92-8.06c1.04-1.06,2.87-1.06,3.92,0c1.07,1.09,1.07,2.87,0,3.96l-9.51,9.69C7.11,22.17,5.82,22.74,4.51,22.74
	z"/>
</svg>;
};

export default React.memo(Attachment);
